module.exports = __webpack_public_path__ + "static/media/equipamentosFortlev.68639cfc.png";